// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2446) return "static/chunks/2446-2e9246d57a19ee7b.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6890":"3d55c2dd72f7af01","9063":"b92dcaf51ed23252","9188":"76a681c651c344e6"}[chunkId] + ".js";
};